import { GetIcon } from '../../../../ui/get-icons';
import { selectedProposalPreparedByName } from '../../../../../features/gms-state-and-modal/state-slice';
import { useSelector } from 'react-redux';

interface Props {
    title: string;
    value: string;
    iconType: number;
    primary?: boolean;
}

export default function PreviewDetailsData({ title, value, iconType, primary = false }: Props) {
    const proposalPreparedBy = useSelector(selectedProposalPreparedByName);

    return (
        <div className={`flex min-w-0 items-center gap-2 rounded-md border border-gray-200 bg-gray-50/70 p-2 transition hover:border-[#186cb2]/30 hover:bg-[#186cb2]/5 ${primary ? 'min-h-[58px]' : 'min-h-[52px]'}`}>
            <div className={`border border-[#186cb2]/10 flex h-8 w-8 shrink-0 items-center justify-center rounded-md ${primary ? 'bg-[#186cb2]/10' : 'bg-white'} text-[#186cb2]`}>
                <GetIcon type={iconType} proposalPreparedBy={proposalPreparedBy} />
            </div>
            <div className="min-w-0 flex-1">
                <p title={title} className="truncate text-[9px] font-medium uppercase tracking-wide text-gray-400 sm:text-[10px]">{title}</p>
                <p title={value} className={`truncate text-xs text-gray-800 ${primary ? 'font-semibold' : 'font-medium'}`}>{value || '—'}</p>
            </div>
        </div>
    );
}